import api from './api';

const agencyService = {
  // Get agency dashboard metrics
  getDashboard: async () => {
    try {
      const response = await api.get('/agency/dashboard');
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch agency dashboard:', error);
      throw error;
    }
  },

  // Get all agents in the agency
  getAgents: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await api.get(`/agency/agents${queryParams ? '?' + queryParams : ''}`);
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch agency agents:', error);
      throw error;
    }
  },

  // Get agency commissions
  getCommissions: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await api.get(`/agency/commissions${queryParams ? '?' + queryParams : ''}`);
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch agency commissions:', error);
      throw error;
    }
  },

  // Get agency analytics
  getAnalytics: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await api.get(`/agency/analytics${queryParams ? '?' + queryParams : ''}`);
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch agency analytics:', error);
      throw error;
    }
  },

  // Get agency settings
  getSettings: async () => {
    try {
      const response = await api.get('/agency/settings');
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch agency settings:', error);
      throw error;
    }
  },

  // Update agency settings
  updateSettings: async (data) => {
    try {
      const response = await api.put('/agency/settings', data);
      return response.data;
    } catch (error) {
      console.error('Failed to update agency settings:', error);
      throw error;
    }
  },

  // Get pending applications
  getApplications: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await api.get(`/agency/applications${queryParams ? '?' + queryParams : ''}`);
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch agency applications:', error);
      throw error;
    }
  }
};

export default agencyService;
